import CustomModal from '@/components/CustomModal';
import { ERoleAccess } from '@/enum';
import useAccess from '@/hooks/useAccess';
import { useFormatText } from '@/hooks/useFormatText';
import { ISelectedLessonValue } from '@/types';

interface IBlockLessonModalProps {
  setIsOpen: (isOpen: boolean) => void;
  selectedLesson: ISelectedLessonValue | null;
  onSubmit: () => void;
  isBlockLoading: boolean;
}

const BlockLessonModal = ({
  setIsOpen,
  selectedLesson,
  isBlockLoading,
  onSubmit,
}: IBlockLessonModalProps) => {
  const { hasAccess } = useAccess();

  const { formatText } = useFormatText();
  if (!hasAccess(ERoleAccess.USER_MANAGEMENT)) return null;

  return (
    <CustomModal
      setIsOpen={setIsOpen}
      className="w-150 max-w-[90vw]"
      isFooter
      position="center"
      loadingModal={isBlockLoading}
      cancelButtonProps={{
        label: formatText('common.actions.cancel'),
        desructive: true,
        onClick: () => setIsOpen(false),
        className: 'px-1.5!',
      }}
      confirmButtonProps={{
        label: formatText('user-management.lesson.block-lesson-button'),
        variant: 'primary',
        desructive: true,
        onClick: () => {
          onSubmit();
        },
        loading: isBlockLoading,
      }}
    >
      <div className="w-full text-start space-y-4">
        <h2 className="text-xl leading-7 tracking-[-0.2px]">
          {formatText('user-management.lesson.block-lesson')}
        </h2>
        <p className="text-neutral-secondary">
          {formatText('user-management.block-user-prefix')}{' '}
          <span className="font-bold text-neutral-primary">
            {selectedLesson?.title}?
          </span>
          <br />
          {formatText('user-management.lesson.block-desc')}
        </p>
      </div>
    </CustomModal>
  );
};

export default BlockLessonModal;
